import CustomTimePicker from "@/components/Form/CustomTimePicker";
import CustomSelect from "@/components/Form/InputFields/CustomSelect";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";

export const ConditionDateField = ({
  name,
  fieldArrayName: fieldName,
  control,
  index,
  error,
  label = null,
  fieldType
}: ConditionField) => {
  const fieldArray = useWatch({
    name: fieldName,
    control,
  });

  return (
    <>
      <CustomTimePicker
        label={label}
        name={name}
        control={control}
        error={error}
        placeholder="hh:mm am/pm"
        timePickerProps={{
          views: ["hours"],
          ...(fieldType === "endTime" && fieldArray[index]?.startTime
            ? { minTime: dayjs(fieldArray[index]?.startTime) }
            : {}),
        }}
        disabled={fieldType === "startTime" ? !fieldArray[index]?.endDay : fieldType === "endTime" ? !fieldArray[index]?.startTime : false}
        isReadOnly
      />
    </>
  );
};

export const ConditionDayField = ({
  name,
  fieldArrayName: fieldName,
  control,
  index,
  error,
  itemList,
  label,
  fieldType
}: ConditionDayField) => {
  const fieldArray = useWatch({
    name: fieldName,
    control,
  });

  const getSelectList = (minValue?: number) =>
    minValue ? itemList.filter((item) => item.value >= minValue) : itemList;

  return (
    <>
      <CustomSelect
        label={label}
        name={name}
        control={control}
        itemList={getSelectList(fieldArray[index]?.startDay)}
        error={error}
        disabled={fieldType === "endDay" ? !fieldArray[index]?.startDay : false}
      />
    </>
  );
};

type ConditionField = {
  name: string;
  fieldArrayName: string;
  control: any;
  index: number;
  register?: any;
  error: any;
  label?: string | null;
  fieldType: "endDay" | "startTime" | "endTime"
};

type ConditionDayField = ConditionField & {
  itemList: {
    label: string;
    value: number;
  }[];
};
